import "./detials.css"
import { useNavigate } from "react-router-dom";

function FiveServices(){
                  const navigate = useNavigate();

    return(
        <>
        <div className="servicedetials">
            <div className="row">
                <div className="col-md-12">
<div className="box">
    <i className="fas fa-brain"></i>
    <h4>Mental Health and Psychological Support Clinic</h4>
    <p>
        Offers individual and group counseling and therapy sessions for a wide range of psychological disorders such as stress, depression, and anxiety. Services are provided under the supervision of psychiatrists and social specialists, and include cognitive behavioral therapy techniques, family counseling sessions, and support programs to help patients adapt to life pressures and improve emotional management skills.
    </p>
    <p>April 28, 2025</p>
</div>
                </div>
            </div>
           <div className="row  m-2">
    <div className="buttons">
  
     <button
      className="btn w-100 btn-warning m-2"
      onClick={() => navigate(-1)}
    >
      <i className="fas fa-exclamation-triangle w-100"></i>
      Return to Service
    </button>

  
  </div>
</div>
        </div>
        </>
    )
}
export default FiveServices